import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProgramtypeRoutingModule } from './programtype-routing.module';
import { ProgramtypeListComponent } from './programtype-list/programtype-list.component';
import { ProgramtypeCreateComponent } from './programtype-create/programtype-create.component';

import { ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Ng2SmartTableModule } from 'ng2-smart-table';

@NgModule({
  declarations: [ProgramtypeListComponent, ProgramtypeCreateComponent],
  imports: [
    CommonModule,
    ProgramtypeRoutingModule,
    ReactiveFormsModule,
    NgbModule,
    Ng2SmartTableModule
  ]
})
export class ProgramtypeModule { }
